import React from 'react';

import { Textarea } from '@mantine/core';
import { OnboardingStepTemplate } from 'pages/Onboarding/OnboardingSteps/OnboardingStepTemplate';
import { useTranslation } from 'react-i18next';

interface DiscoverySourceStepProps {
  updateOnboardingDiscoverySource: (discoverySource: string) => void;
}

export function DiscoverySourceStep({ updateOnboardingDiscoverySource }: DiscoverySourceStepProps) {
  const { t } = useTranslation();

  return (
    <OnboardingStepTemplate
      title={{
        text: t('ONBOARDING.DISCOVERY_SOURCE_STEP.TITLE')
      }}
      description={t('ONBOARDING.DISCOVERY_SOURCE_STEP.DESCRIPTION')}
      rightElement={
        <Textarea
          minRows={3}
          maxRows={3}
          placeholder={t('ONBOARDING.DISCOVERY_SOURCE_STEP.PLACEHOLDER')}
          onChange={(event) => updateOnboardingDiscoverySource(event.currentTarget.value)}
        />
      }
    />
  );
}
